import { useMarkProjectAsComplete } from '@/api/carbon.api';
import MarkAsCompleteBase from '@/modules/MarkAsComplete/MarkAsCompleteBase';

type Props = {
  projectId: string | undefined;
  isComplete: boolean;
  setReportRefetching: (reportRefetching: boolean) => void;
};

const MarkProjectAsComplete = ({ projectId, isComplete, setReportRefetching }: Props) => {
  const markProjectAsCompleteMutation = useMarkProjectAsComplete();

  return (
    <MarkAsCompleteBase
      entityId={projectId}
      entityType="project"
      isComplete={isComplete}
      setReportRefetching={setReportRefetching}
      markAsCompleteMutation={markProjectAsCompleteMutation}
    />
  );
};

export default MarkProjectAsComplete;
